export default __webpack_public_path__ + "static/media/sap.76dc42e1.jpg";